import { ImageX } from '@untitledui/icons'

import TransformableImage from '@components/productImage/TransformableImage'

function ProductImage({ src }: {src?: string}) {
  return (
    <div className="flex aspect-square w-full items-center justify-center rounded-sm bg-gray-200 p-3">
      {
        src ?
          <TransformableImage
            type="productCard"
            src={src}
            loading='lazy'
            className='max-h-full max-w-full object-contain'
          />
          :
          <ImageX className='text-gray-500' />
      }
    </div>
  )
}

ProductImage.Skeleton = function ProductImageSkeleton() {
  return (
    <div className="flex aspect-square w-full animate-pulse items-center justify-center rounded-sm bg-gray-200 p-3">
      &nbsp;
    </div>
  )
}

export default ProductImage